module.exports = __webpack_public_path__ + "static/media/feature-split-image-05.1e4014b3.png";